import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { Clock, Calendar, Brain, TrendingDown } from 'lucide-react';
const urgencyPoints = [{
  icon: Calendar,
  title: 'Seu casamento tem data',
  description: 'Cada dia que passa é um dia a menos para resolver isso. Quanto antes você decidir, mais tranquila você fica.'
}, {
  icon: Brain,
  title: 'A ansiedade só cresce',
  description: 'Você sabe que precisa resolver. Quanto mais você adia, mais essa preocupação ocupa espaço na sua mente.'
}, {
  icon: TrendingDown,
  title: 'Tempo é o recurso mais escasso',
  description: 'Você tem mil coisas para resolver no casamento. Quanto antes tirar as lembrancinhas da lista, melhor.'
}, {
  icon: Clock,
  title: 'Decisão rápida = menos estresse',
  description: 'Imagine acordar amanhã sabendo exatamente o que vai fazer. Essa sensação de alívio não tem preço.'
}];
export function UrgencySection() {
  return <section className="py-24 bg-white" data-id="element-289">
      <div className="max-w-6xl mx-auto px-6" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-291">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-292">
            "Posso Fazer Isso Hoje?"
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-293">
            A resposta é sim. E aqui está por que você deveria:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-294">
          {urgencyPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-gradient-to-br from-rose-50 to-pink-50 p-8 rounded-2xl shadow-lg" data-id="element-295">
              <div className="flex items-start gap-5" data-id="element-296">
                <div className="bg-white p-4 rounded-xl shadow-md flex-shrink-0" data-id="element-297">
                  <point.icon className="w-8 h-8 text-rose-600" data-id="element-298" />
                </div>
                <div data-id="element-299">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-300">
                    {point.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-301">
                    {point.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-gradient-to-r from-rose-500 to-pink-600 p-12 rounded-3xl shadow-2xl text-white text-center" data-id="element-302">
          <h3 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-303">
            Resolva Isso Agora. Durma Tranquila Hoje à Noite.
          </h3>

          <p className="text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto mb-10" data-id="element-304">
            Em menos de 5 minutos, você terá acesso a 40 ideias prontas. Em
            menos de 1 hora, você já terá escolhido as suas favoritas. E amanhã?
            Amanhã você acorda com essa preocupação{' '}
            <span className="font-bold" data-id="element-305">completamente resolvida</span>.
          </p>

          <CTAButton variant="secondary" size="large" data-id="element-306">
            Quero Resolver Isso Agora
          </CTAButton>

          <p className="text-sm mt-6 opacity-90" data-id="element-307">
            Acesso imediato após o pagamento • Disponível 24/7 • Suporte
            dedicado
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.7,
        duration: 0.6
      }} className="mt-12 text-center" data-id="element-308">
          <p className="text-lg text-gray-600" data-id="element-309">
            Você está a{' '}
            <span className="font-bold text-rose-600" data-id="element-310">um clique</span> de
            transformar essa ansiedade em confiança.
          </p>
        </motion.div>
      </div>
    </section>;
}